export default __webpack_public_path__ + "static/media/marketing_1.5886a07d.jpeg";